module.exports = __webpack_public_path__ + "img/icon-mall.94965dd3.png";